import { Component, OnInit, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { takeWhile } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { getCurrencySymbol } from '@angular/common';

import * as FlightFareInformationActions from '@ibe/store/actions/fare-information.indra.action';
import { INDRA_getCheckedBaggageDetails } from '@ibe.components/booking/flights/brand/brand.indra';

import { INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

import {
	COMMERCIAL_ECONOMY_BRANDS,
	COMMERCIAL_BUSINESS_BRANDS,
	TAP_AWARD_BRANDS,
	STAR_ALLIANCE_AWARD_BRANDS,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS,
	BASIC_ANCILLARY_CODES_MEALS,
	SSR_CODE_MEAL_MEALS_AND_BEVERAGES,
	SSR_CODE_MEAL_SNACK,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_PREMIUM_BOARDING,
	BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_LOUNGE
} from '@ibe.config';

// import { getBrandFeaturesCorp } from '@ibe.components/corporate/flights/brand/brand';

@Component({
	selector: 'app-compare-brands',
	templateUrl: './compare-brands.indra.component.html',
	styleUrls: ['./compare-brands.component.scss']
})
export class INDRACompareBrandsComponent implements OnInit {

	@Input() feature: INDRAFeature;
	@Input() brand: string;
	@Input() segment?: number;
	@Input() snack?: boolean;

	featureBrandsMatrix;
	brands = [];

	private isAlive = true;

	flightFareInformation$: Observable<any> = this.store.select(fromStore.getFlightFareInformation);
	flightFareInformation;

	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;

	constructor(
		private store: Store<fromStore.State>,
		protected route: ActivatedRoute,
		protected router: Router,
		private ancillariesService: INDRAAncillariesService,
		private ibeAdminService: INDRAIbeAdminService) {
		this.flightFareInformation$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.flightFareInformation = value;
		});
	}

	ngOnInit() {
		let brandGroupFilter = null;
		if (this.brand) {
			if (COMMERCIAL_ECONOMY_BRANDS.includes(this.brand)) {
				brandGroupFilter = COMMERCIAL_ECONOMY_BRANDS;
			}
			else if (COMMERCIAL_BUSINESS_BRANDS.includes(this.brand)) {
				brandGroupFilter = COMMERCIAL_BUSINESS_BRANDS;
			}
			else if (TAP_AWARD_BRANDS.includes(this.brand)) {
				brandGroupFilter = TAP_AWARD_BRANDS;
			}
			else if (STAR_ALLIANCE_AWARD_BRANDS.includes(this.brand)) {
				brandGroupFilter = STAR_ALLIANCE_AWARD_BRANDS;
			}
		}

		// filter flightFareInformation list to contain only the brands included in the current brands group
		let filteredFlightFareInformation;
		if (brandGroupFilter && this.flightFareInformation && this.flightFareInformation.length > 0) {
			filteredFlightFareInformation = this.flightFareInformation.filter(
				fareInfo => fareInfo && brandGroupFilter.includes(fareInfo.name));
		}

		// get feature with brand matrix
		if (filteredFlightFareInformation) {

			const sortedFlightFareInformation =
				filteredFlightFareInformation.sort(this.INDRA_orderByBrandHierarchy(brandGroupFilter));

			this.featureBrandsMatrix =
				this.ancillariesService.getFeaturePerBrand(this.feature.code, sortedFlightFareInformation);
			this.brands = this.featureBrandsMatrix.brands;
		}

	}

	INDRA_printLabel(brand) {
		const feature = brand.feature;
		const featureAmount = this.INDRA_getAmount(feature);
		const amount = featureAmount ? `<span class="bold">${featureAmount} x </span>` : '';
		const translatedAncillaryLabel = this.INDRA_getTranslation(feature.labelTranslationKey);

		let label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.no') + ' ' + translatedAncillaryLabel;
		if (feature.free) {
			if (feature.code === BASIC_ANCILLARY_CODES_SEAT_RESERVATION) {
				switch ((brand.name).toLowerCase()) {
					case 'executive':
					case 'top-executive':
						label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.freeIncludedPerPassengerExecutive');
						break;
					case 'classic':
					case 'miles&go-economy':
						label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassengerClassic');
						break;
					case 'plus':
						label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassengerPlus');
						break;
					default:
						if ((sessionStorage.getItem('language').toLowerCase()) == 'pt') {
							label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.freeIncludedPerPassengerDefaultPT');
						} else {
							label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.free') + ' ' +
								translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassengers');
							label = this.capitalize(label);
						}
						break;
				}
			} else if (feature.code === BASIC_ANCILLARY_CODES_MEALS) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.MEALS');
			} else if (feature.code === BASIC_ANCILLARY_CODES_HAND_BAGGAGE) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.HANDBAG');
			} else if (feature.code === BASIC_ANCILLARY_CODES_MILES) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.MILES');
			} else if (feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.CHECKEDBAG');
			} else if (feature.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.CHANGES');
			} else if (feature.code === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS) {
				label = `${amount}` + this.INDRA_getTranslation('ancillaries.group.refundable') + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.REFUNDS');
			} else if (feature.code === BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.PCHECK');
			} else if (feature.code === BASIC_ANCILLARY_CODES_FASTTRACK) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.FAST');
			} else if (feature.code === BASIC_ANCILLARY_CODES_LOUNGE) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.LOUNGE');
			} else if (feature.code === BASIC_ANCILLARY_CODES_PREMIUM_BOARDING) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.PBOARD');
			} else if (feature.code === BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE) {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassenger.PBAG');
			} else {
				label = `${amount}` + translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.includedPerPassengers');
			}

			// check if flight has segments and if segment has included meals
			if (this.segment != null && feature.code === BASIC_ANCILLARY_CODES_MEALS) {
				if(!this.snack) {
					if (feature['segmentIncluded'] && feature['segmentIncluded'].length && !feature.segmentIncluded.includes(this.segment.toString())) {
						label = this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.no') + ' ' + translatedAncillaryLabel;
					}
				}
			}
		} else if (feature.code === BASIC_ANCILLARY_CODES_FLIGHT_CHANGES || feature.code === BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS) {
			label = this.INDRA_getTranslation('ancillaries.texts.chargeable');
		} else {
			label = this.INDRA_getNotIncludedFeatureLabel(brand, feature, translatedAncillaryLabel);
		}
		
		return label;
	}

	INDRA_getNotIncludedFeatureLabel(brand, feature, translatedAncillaryLabel) {
		let label;
		if (feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE) {
			if (brand.name.toLowerCase() === 'discount') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedFBAGDiscount');
			}				
		} else if (feature.code === BASIC_ANCILLARY_CODES_SEAT_RESERVATION) {
			if (brand.name.toLowerCase() === 'discount') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedRQSTDiscount');
			} else if (brand.name.toLowerCase() === 'basic') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedRQSTBasic');
			}
		} else if (feature.code === BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN) {
			if (brand.name.toLowerCase() === 'discount') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedPCHECKDiscount');
			} else if (brand.name.toLowerCase() === 'basic') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedPCHECKBasic');
			} else if (brand.name.toLowerCase() === 'classic') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedPCHECKClassic');
			}
		} else if (feature.code === BASIC_ANCILLARY_CODES_FASTTRACK) {
			if (brand.name.toLowerCase() === 'discount') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedFASTDiscount');
			} 
		} else if (feature.code === BASIC_ANCILLARY_CODES_PREMIUM_BOARDING) {
			if (brand.name.toLowerCase() === 'miles&go-economy') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedPremiumBoardingMG');
			}
		} else if (feature.code === BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE) {
			if (brand.name.toLowerCase() === 'miles&go-economy') {
				label = translatedAncillaryLabel + ' ' + this.INDRA_getTranslation('whatsIncludedSidebars.general.texts.notIncludedPBAGGMG');
			}
		}
		return label;
	}

	INDRA_getAmount(feature) {
		let amount;
		if (feature && feature.code === BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE &&
			feature.includedAncillaries && feature.includedAncillaries.length > 0) {
			// assumption is only 1 baggage ancillary will be included during initial booking
			const holdBaggageAncillaryCode = feature.includedAncillaries[0];
			const ancillaryBaggageDetails = INDRA_getCheckedBaggageDetails(holdBaggageAncillaryCode);
			if (ancillaryBaggageDetails) {
				amount = ancillaryBaggageDetails.count;
			}
		}
		return amount;
	}

	private INDRA_orderByBrandHierarchy(orderList) {
		return function (a, b) {
			const aIdx = orderList.indexOf(a.name);
			const bIdx = orderList.indexOf(b.name);
			if (aIdx < bIdx) return -1;
			else if (aIdx > bIdx) return 1;
			else return 0;
		}
	}

	private INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

}
